import React from "react";

import {Badge, Button, Card, CardBody, CardText, Col, Row} from "reactstrap";
import Project_technology from "../containers/project_technologies";

const ProjectsCard = ({ data }) => {
	return (
		<Col lg="12">
				<Card   className="shadow-lg--hover shadow border-0 text-center rounded  shadow mt-4 " >
					<CardBody >
						<div className="d-flex px-3">
							<div className="pl-4">
								<h3>{data.name}</h3>
								<Badge color="info" className="mr-1">
									{data.duration}
								</Badge>
								<CardText className="description my-3 text-left">
									{data.desc}
								</CardText>
								<Row className="row-grid align-items-center">
								 <Col className="order-lg-1" lg="12" >
									 <h5 className="text-info">
										 Technologies
									 </h5>
								 </Col>
								</Row>
								<Project_technology technology={data.technology}/>
								{data.github ? (
									<Button
										className="btn-icon"
										color="github"
										href={data.github}
										target="_blank"
									>
										<span className="btn-inner--icon">
											<i className="fa fa-github" />
										</span>
									</Button>
								) : null}
								{data.link ? (
									<Button
										className="btn-icon"
										color="success"
										href={data.link}
										target="_blank"
									>
										<span className="btn-inner--icon">
											<i className="fa fa-arrow-right mr-2" />
										</span>
										<span className="nav-link-inner--text ml-1">
											Demo
										</span>
									</Button>
								) : null}

							</div>
							<div className="d-flex px-3">
							</div>
						</div>
					</CardBody>
				</Card>
		</Col>
	);
};

export default ProjectsCard;
